"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.processValue = exports.getInitialValue = void 0;
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// Previously value was just an array of selected options
// Then we decided to save additional information such as userText
// That's why we need this function to convert array to object to not have breaking changes
var processValue = exports.processValue = function processValue(value) {
  if (_typeof(value) === 'object' && value.selected) {
    return _objectSpread({
      selectedLabels: {},
      userTexts: {}
    }, value);
  }
  return {
    selected: value || [],
    selectedLabels: {},
    userTexts: {}
  };
};
var getInitialValue = exports.getInitialValue = function getInitialValue() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultValueVariables = arguments.length > 1 ? arguments[1] : undefined;
  var _settings$options = settings.options,
    options = _settings$options === void 0 ? [] : _settings$options,
    optionTypes = settings.optionTypes,
    defaultValueVariable = settings.defaultValueVariable;
  if (defaultValueVariable) {
    if (defaultValueVariables) {
      var defaultValue = (0, _get2["default"])(defaultValueVariables, defaultValueVariable);
      if (!defaultValue) {
        console.error("There is no variable \"".concat(defaultValueVariable, "\""));
      } else if (!(0, _isArray2["default"])(defaultValue)) {
        console.error("The value of \"".concat(defaultValueVariable, "\" variable should be an array"));
      } else {
        return defaultValue;
      }
    }
  } else {
    var result = [];
    options.forEach(function (option) {
      if (option.type === 'static') {
        var optionType = (0, _find2["default"])(optionTypes[option.type], {
          id: option.id
        });
        if (optionType.isDefault) {
          result.push(option.id);
        }
      }
    });
    if (result.length > 0) {
      return result;
    }
  }
  return undefined;
};
var validate = exports.validate = function validate(value, settings) {
  var error;

  // Just to not to break old format
  if (Array.isArray(value)) {
    value = {
      selected: value
    };
  }
  var visualType = settings.visualType,
    singleAnswerRequired = settings.singleAnswerRequired,
    singleOrMultiple = settings.singleOrMultiple,
    requiredErrorMessage = settings.requiredErrorMessage,
    multiAnswerMin = settings.multiAnswerMin,
    multiAnswerMax = settings.multiAnswerMax,
    minAnswersErrorMessage = settings.minAnswersErrorMessage,
    maxAnswersErrorMessage = settings.maxAnswersErrorMessage;
  if (visualType === 'radio' || visualType === 'dropdown' || visualType === 'image' && singleOrMultiple === 'single' || visualType === 'button' && singleOrMultiple === 'single') {
    if (singleAnswerRequired) {
      if (!value || value.selected.length === 0) {
        return requiredErrorMessage;
      }
    }
  }
  if (visualType === 'checkbox' || visualType === 'button' && singleOrMultiple === 'multiple' || visualType === 'image' && singleOrMultiple === 'multiple') {
    if (multiAnswerMin) {
      if (!value || value.selected.length < +multiAnswerMin) {
        return (0, _cccisdSurveyCommon.replaceVars)(minAnswersErrorMessage, {
          min: multiAnswerMin
        });
      }
    }
    if (multiAnswerMax) {
      if (value && value.selected.length > +multiAnswerMax) {
        return (0, _cccisdSurveyCommon.replaceVars)(maxAnswersErrorMessage, {
          max: multiAnswerMax
        });
      }
    }
  }
  return error;
};